import { Controller } from "@hotwired/stimulus";
import Swiper, { Navigation, Pagination } from 'swiper';

export default class extends Controller {
  connect () {
    const swiper = new Swiper('.swiper', {
      direction: 'horizontal',
      loop: false,
      autoHeight: false,
      slidesPerView: 1,
      modules: [
        Navigation,
        Pagination
      ],
      wrapperClass: 'swiper-wrapper',
      pagination: {
        el: '.swiper-pagination'
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });
  }
}